import { render, staticRenderFns } from "./PaymentSelection.vue?vue&type=template&id=6310d56b"
import script from "./PaymentSelection.vue?vue&type=script&lang=js"
export * from "./PaymentSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports